var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.series.length)?_c('div',{staticClass:"flex flex-col"},[_c('series-grid-section',{staticClass:"flex-grow pt-32",attrs:{"series":_vm.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }